import * as React from 'react';
import { StaticSettings } from '../../StaticSettings';
import { AbstractApplyNowButton } from './AbstractApplyNowButton';

/**
 * Button in the style of a shopping cart, to apply to all the selected Job Vacancies
 */
export class ApplyNowButtonWidget extends AbstractApplyNowButton {
    public render() {
        if (!StaticSettings.ui.allowApplyToMultiple) {
            return null;
        }

        const selectedModels = this.props.selectedModels;
        const count = selectedModels.length;
        const className = this.getClassName(selectedModels);
        const title = this.getTitle(selectedModels);

        return <button className={className + ' -widget'} title={title} onClick={this.handleClick}>
            <span className="count">{count}</span>
            <i className="fas fa-paper-plane"/>
        </button>;
    }
}
